import ItemViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemViewState';
import Message from 'owa-service/lib/contract/Message';
import { action } from 'satcheljs';

/**
 * Action to initialize read receipt sending to the user
 */
export default action(
    'initializeSendingReadReceipt',
    (message: Message, key: string, itemViewState: ItemViewState) => ({
        message,
        key,
        itemViewState,
    })
);
